import ActionsColumn, { cellType, actionColumnConfiguration } from './ActionsColumn.component';

export { cellType, ActionsColumn };
export default actionColumnConfiguration;
